import getters from '@/store/modules/person/getters'
import mutations from '@/store/modules/person/mutations'
import actions from '@/store/modules/person/actions'

export default {
  namespaced: true,
  state() {
    return {}
  },
  getters,
  actions,
  mutations
}
